import {Component, OnInit} from '@angular/core';
import {UserFilter, UserModel} from '../../models/authentication/user.model';
import {Router} from '@angular/router';
import {AdminUserService} from '../../services/admin/admin-user.service';
import {CountryModel} from '../../models/localization-and-pricing/country.model';
import {EVOUserListSort} from '../../shared/list-views/evo-users-list-view/evo-users-list-view.component';
import {forkJoin} from 'rxjs';
import {ModalService} from '../../shared/modals/modal/modal.service';

@Component({
  selector: 'app-school-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.css']
})
export class AdminUsersComponent implements OnInit {

  users: UserModel[] = [];
  usersToDelete: UserModel[] = [];

  password = '';
  secret = '';

  filter = new UserFilter();
  hasMoreData = true;
  countryDropdownList = CountryModel.privateDropdownList(true);

  showConfirmationPrompt = false;

  constructor(private router: Router,
              private modalSv: ModalService,
              private adminUserSrv: AdminUserService) {
  }

  ngOnInit() {
    this.filter.limit = 20;
    this.fetchUsers();
  }

  fetchUsers() {

    this.filter.skip = this.users.length;
    this.adminUserSrv.fetchUsers(this.filter).subscribe((users) => {

      this.hasMoreData = this.filter.limit === users.length;
      this.users.addUniqueArrayElements(users);

    });

  }

  onEmpty() {

    this.filter.ids = undefined;
    this.filter.name = undefined;

    this.users = [];

    this.fetchUsers();

  }

  onSearchCountry(country: string) {

    if (!country || country.length === 0) {
      this.filter.country = undefined;
    } else {
      this.filter.country = country;
    }

    this.users = [];
    this.fetchUsers();

  }

  onSearchById(ids: string) {

    if (!ids || ids.length === 0) {
      this.filter.ids = undefined;
    } else {
      this.filter.ids = ids;
    }

    this.users = [];
    this.filter.name = undefined;
    this.fetchUsers();

  }

  onSearchByName(name: string) {

    if (!name || name.length === 0) {
      this.filter.name = undefined;
    } else {
      this.filter.name = name;
    }

    this.users = [];
    this.filter.ids = undefined;
    this.fetchUsers();

  }

  searchFilteredUsers(searchString: string, country: string) {

    this.filter.name = searchString;
    this.filter.email = searchString;
    this.filter.country = country;
    this.users = [];
    this.fetchUsers();

  }

  onSortClicked(sort: EVOUserListSort) {

    this.filter.sort = sort.value;
    this.users = [];
    this.fetchUsers();

  }

  height(): string {

    if (this.usersToDelete.length > 0) {
      return 'calc(100% - 236px);';
    }

    return 'calc(100% - 176px);';
  }

  heightXS(): string {

    if (this.usersToDelete.length > 0) {
      return 'calc(100% - 302px';
    }

    return 'calc(100% - 242px);';
  }

  onDeleteMultipleUsers() {

    const list = [];
    for (const user of this.usersToDelete) {
      const deleteOp = this.adminUserSrv.deleteUser(user._id, this.password, this.secret);
      list.push(deleteOp);
    }

    forkJoin(list).subscribe(() => {
      this.showConfirmationPrompt = false;
      this.password = '';
      this.secret = '';
      this.modalSv.showAlertModal('Success', 'Users were successfully deleted');
      this.usersToDelete = [];
      this.users = [];
      this.filter.skip = 0;
      this.fetchUsers();
    });

  }

  onHidePrompt() {
    this.showConfirmationPrompt = false;
    this.password = '';
    this.secret = '';
  }

  onUserClicked(user: UserModel) {
    this.router.navigate(['admin', 'users', user._id, 'detail', 'settings']);
  }

}
